import React from "react";
import EnergyAssetsCard from "./EnergyAssetsCard";
import Loader from "../../components/Loader";

const ThermalPower = ({ energyAssetsData = [], isLoading }) => {
  const ThermalPowerPlants = energyAssetsData.filter(
    (plant) => plant.field_category_page_assets === "Thermal Power",
  );

  if (isLoading) {
    return <Loader />;
  }

  // Check if there are no thermal power plants
  if (ThermalPowerPlants.length === 0) {
    return <div>No thermal power plants available</div>;
  }

  return (
    <div className="hydro-power-box1b aos-init aos-animate ">
      <ul>
        {ThermalPowerPlants.map((item, index) => (
          <EnergyAssetsCard plantData={item} key={index} />
        ))}
      </ul>
    </div>
  );
};

export default ThermalPower;
